import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import {
  NgbDropdownModule, NgbNavModule, NgbPaginationModule, NgbTypeaheadModule,
  NgbHighlight, NgbAccordionModule, NgbModule, NgbActiveModal, NgbCollapseModule
} from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
// import { DataTablesModule } from 'angular-datatables';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { AgGridModule } from 'ag-grid-angular';
import { UserManagementRoutingModule } from './user-management-routing.module';

import { AddRolesComponent } from '../../components/user-management/roles/addroles.component'; 

import { ListUsersComponent } from '../../components/user-management/users/list/listusers.component'; 
import { AddUsersComponent } from '../../components/user-management/users/add/addusers.component'; 
import { EditUsersComponent } from '../../components/user-management/users/edit/editusers.component'; 

//Service
import { CompanyService } from 'src/app/services/company.service';
import { UserManagementService } from 'src/app/services/user-management.service';
import { NetworkService } from 'src/app/services/network.service';
import { EditRoleComponent } from '../../components/user-management/roles/editrole.component';
import { EditUserPermissionComponent } from '../../components/user-management/users/edit-permissions/editpermissions.component'; 
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { CustomerService } from 'src/app/services/customer.service';

@NgModule({
  declarations: [
    AddRolesComponent,
    EditRoleComponent,
    ListUsersComponent,
    AddUsersComponent,
    EditUsersComponent,
    EditUserPermissionComponent
  ],
  imports: [
    CommonModule,
    UserManagementRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgbModule,
    NgbHighlight,
    NgbNavModule,
    NgbDropdownModule,
    NgbTypeaheadModule,
    NgbPaginationModule,
    NgSelectModule,
    // DataTablesModule,
    CKEditorModule,
    AgGridModule,
    NgbAccordionModule,
    NgbCollapseModule,
    NgMultiSelectDropDownModule
  ],
  exports: [
    AddRolesComponent,
    EditRoleComponent,
    ListUsersComponent,
    AddUsersComponent,
    EditUsersComponent,
    EditUserPermissionComponent
  ],
  providers: [NetworkService, CompanyService, UserManagementService, NgbActiveModal, CustomerService]
})
export class UserManagementModule { }
